<div class="panel panel-primary">
  <div class="panel-heading">
    {{ member.MemberName }} - Member Information Update Form
  </div>
  <div class="panel-body">
    <form class="form-horizontal" role="form" data-testid="edit-member-form">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 text-center">
          <h1>
            {{
              member.FirstName + " " + member.MiddleName + " " + member.LastName
            }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6">
          <div *ngIf="member.ImageExists">
            <img
              class="thumbnail img-responsive"
              width="250px"
              height="300px"
              src="Content/images/members/{{ member.MemberId }}.jpg"
              alt="{{ member.MemberId }}"
            />
            <br />
            <b> {{ member.MemberId }}</b>
          </div>
          <div *ngIf="!member.ImageExists" data-testid="edit-member-form-member-id">{{ member.MemberId }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6 col-sm-4">
          <label  for="birthDate" class="control-label">Date of Birth</label><span style="color: red">*</span>
          <!--<input class="form-control" dateInput type="text" name="startDate" placeholder="MM/dd/yyyy" [(ngModel)]="BirthDate"  required required-message="'Date of Birth is required'"/>-->
          <p class="input-group">
            <input
              type="text"
              class="form-control"
              data-testid="edit-member-form-b-day"
              name="birthDate"
              id="birthDate"
              validate-on="blur"
              required-message="'Date of Birth is required'"
              bsDatepicker
              [bsConfig]="{ containerClass: 'theme-red',  dateInputFormat: 'YYYY-MM-DD'}"
              #dp="bsDatepicker"
              [(ngModel)]="member.BirthDate"
            />
            <span class="input-group-btn">
              <button
                type="button"
                class="btn btn-default"
                data-testid="edit-member-form-calender-button"
                (click)="dp.show()"
                [attr.aria-expanded]="dp.isOpen"
              >
                <i class="glyphicon glyphicon-calendar"></i>
              </button>
            </span>
          </p>
        </div>
        <div class="col-xs-6 col-sm-4">
          <label for="phone" class="control-label"><i class="fa fa-phone-square" aria-hidden="true"></i>Primary Phone</label><span style="color: red">*</span>
          <p class="input-group">
            <input
              class="form-control"
              data-testid="edit-member-form-phone"
              name="phone"
              id="phone"
              type="text"
              [(ngModel)]="member.Phone"
              validate-on="blur"
            />
          </p>
        </div>
        <div class="col-xs-6 col-sm-4">
          <br>
        </div>
      </div>
      <div class="alert alert-success">
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <label for="address_1" class="control-label">Address Line 1</label>
            <input
              class="form-control"
              data-testid="edit-member-form-address-1"
              name="address_1"
              id="address_1"
              type="text"
              [(ngModel)]="member.Address_1"
              validate-on="blur"
            />
          </div>
          <div class="col-xs-12 col-sm-6">
            <label for="address_2" class="control-label">Address Line 2</label>
            <input
              class="form-control"
              data-testid="edit-member-form-address-2"
              name="address_2"
              id="address_2"
              type="text"
              [(ngModel)]="member.Address_2"
              validate-on="blur"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <label for="city" class="control-label">City</label>
            <input
              class="form-control"
              data-testid="edit-member-form-city"
              name="city"
              id="city"
              type="text"
              [(ngModel)]="member.City"
              validate-on="blur"
            />
          </div>
          <div class="col-xs-12 col-sm-2">
            <label for="state" class="control-label">State</label>
            <input
              class="form-control"
              data-testid="edit-member-form-state"
              name="state"
              id="state"
              type="text"
              [(ngModel)]="member.State"
              validate-on="blur"
            />
          </div>
          <div class="col-xs-12 col-sm-4">
            <label for="zip" class="control-label">Zip</label>
            <input
              class="form-control"
              data-testid="edit-member-form-zip"
              name="zip"
              id="zip"
              type="text"
              [(ngModel)]="member.Zip"
              validate-on="blur"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12">
            <span style="color: red; font-size: small"><i></i></span>
          </div>
        </div>
      </div>
      <div class="alert alert-info">
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <label for="selectedPicketline" class="control-label">Picket Line: </label>
            <select
              data-testid="edit-member-form-picket"
              name="selectedPicketline"
              id="selectedPicketline"
              class="form-control black"
              [(ngModel)]="member.StrikeLine"
            >
              <option
                *ngFor="let option of picketLines"
                value="{{ option.PicketLineName }}"
              >
                {{ option.PicketLineName }}
              </option>
            </select>
          </div>
          <div class="col-xs-12 col-sm-6">
            <label for="selectedShift" class="control-label">Shift preference: </label>
            <select
              data-testid="edit-member-form-shift"
              name="selectedShift"
              id="selectedShift"
              class="form-control black"
              [(ngModel)]="member.StrikeShift"
            >
              <option
                *ngFor="let option of shifts"
                value="{{ option.ShiftName }}"
              >
                {{ option.ShiftName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row alert alert-warning">
        <div class="col-xs-12 col-sm-6">
          <label for="debitCard" class="control-label">Debit Card</label>
          <input
            class="form-control"
            name="debitCard"
            data-testid="edit-member-form-debit-card"
            id="debitCard"
            type="text"
            [(ngModel)]="member.DebitCard"
            validate-on="blur"
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label for="newDebitCard" class="control-label">New Debit Card</label>
          <input
            class="form-control"
            name="newDebitCard"
            data-testid="edit-member-form-new-debit-card"
            id="newDebitCard"
            type="text"
            validate-on="blur"
            value="{{ newDebitCardSwipeInfo }}"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="row alert alert-warning">
        <div class="col-xs-12 col-sm-9">
          <label for="newDebitCardInfo" class="control-label">New Debit Card swipe here....</label>
          <input
            class="form-control"
            data-testid="edit-member-form-new-debit-swipe"
            name="newDebitCardInfo"
            id="newDebitCardInfo"
            type="text"
            [(ngModel)]="newDebitCardSwipeInfo"
            validate-on="blur"
          />
        </div>
      </div>
    </form>
  </div>
  <div class="panel-footer clearfix">
    <div class="pull-right">
      <button type="button" class="btn btn-danger" (click)="cancelAction()">
        Cancel
      </button>
      <button
        type="button"
        data-testid="edit-member-form-submit"
        class="btn btn-primary"
        (click)="updateMember()"
        [disabled]="disableButton"
      >
        Update
      </button>
    </div>
  </div>
</div>
